import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getCallListData } from './mockData'
import type { THrid } from '~/types/models'
import type { ICall } from '~/types/call/models'

interface GetCallsResponse {
  data: ICall[]
}

async function getCalls(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`'Returning calls.`)
  const responseBody: GetCallsResponse = { data: await getCallListData() }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postCall = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getCallListData)
}

const patchCall = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getCallListData)
}

const deleteCall = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getCallListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/calls',
    handler: getCalls,
  },
  {
    method: 'post',
    path: '/api/calls',
    handler: postCall,
  },
  {
    method: 'patch',
    path: '/api/calls/:id',
    handler: patchCall,
  },
  {
    method: 'delete',
    path: '/api/calls/:id',
    handler: deleteCall,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
